(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/init.js');
'use strict';

const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const log = svs.core.log;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const Integrity = svs.termsIntegrity.integrity.Integrity;
const Rules = svs.termsIntegrity.rules.Rules;
const Terms = svs.termsIntegrity.terms.Terms;
const TermsIntegrityReduxProvider = svs.termsIntegrity.store.TermsIntegrityReduxProvider;
const _svs$termsIntegrity$c = svs.termsIntegrity.constants.route,
  TIR_HOME = _svs$termsIntegrity$c.TIR_HOME,
  TIR_TERMS = _svs$termsIntegrity$c.TIR_TERMS,
  TIR_INTEGRITY = _svs$termsIntegrity$c.TIR_INTEGRITY,
  TIR_RULES = _svs$termsIntegrity$c.TIR_RULES;
svs.termsIntegrity.init = () => {
  svs.termsIntegrity.logger = new log.Logger('module:termsIntegrity');
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    className: "bg-white",
    withRouter: true
  }, React.createElement(TermsIntegrityReduxProvider, null, React.createElement(ErrorBoundary, null, React.createElement(Route, {
    component: Terms,
    exact: true,
    path: TIR_HOME
  }), React.createElement(Route, {
    component: Integrity,
    exact: true,
    path: TIR_INTEGRITY
  }), React.createElement(Route, {
    component: Terms,
    exact: true,
    path: TIR_TERMS
  }), React.createElement(Route, {
    component: Rules,
    exact: true,
    path: TIR_RULES
  }))));
  ReactDOM.render(router, document.getElementsByClassName('js-react-container')[0]);
};
svs.termsIntegrity.init();

 })(window);